import {
    MetricContainer,
    MetricsRow,
    MetricsSpace,
} from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import React from "react";
import { connect } from "react-redux";
import DurationService from "app/services/DurationService";
import { OrganicBrandedNonBranded } from "./WWOOrganicBrandedNonBranded";
import { OrganicTopKeywords } from "../WWOTopKeywords";
import { useCurrentStateAndParams } from "@uirouter/react";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const WWOSearchTrafficOrganic = (props) => {
    const {
        showGAApprovedData,
        getKeywordsCtaLink,
        getBrandedNonBrandedCtaLink,
        brandedNonBrandedUnlockHook = null,
        keywordsUnlockHook = null,
    } = props;
    const { params, state } = useCurrentStateAndParams();
    // set webSource to "Total" for WWOSearchTrafficOrganic since it is the only webSource available component
    const webSource = devicesTypes.TOTAL;
    const { country, key, isWWW, duration } = params;
    const configId = proNavigator.getConfigId(state);
    const { forAPI } = DurationService.getDurationData(duration, undefined, configId);
    const { from, to, isWindow } = forAPI;
    const queryParams = React.useMemo(
        () => ({
            country,
            from,
            includeSubDomains: isWWW === "*",
            isWindow,
            keys: key,
            to,
            webSource,
        }),
        [country, from, isWWW, key, to, isWindow],
    );
    const [noDataState, setNoDataState] = React.useState({
        BrandedNonBranded: false,
        topKeywordsOrganic: false,
    });
    if (!key) {
        return null;
    }
    const commonProps = { queryParams, noDataState, setNoDataState };
    return (
        <MetricsRow>
            <MetricContainer
                width={"55%"}
                height={"305px"}
                padding={0}
            >
                <OrganicBrandedNonBranded
                    {...commonProps}
                    routingParams={{ ...params, showGAApprovedData }}
                    getCtaLink={getBrandedNonBrandedCtaLink}
                    unlockHook={brandedNonBrandedUnlockHook}
                />
            </MetricContainer>
            <MetricsSpace />
            <MetricContainer
                width={"55%"}
                height={"305px"}
                padding={0}
            >
                <OrganicTopKeywords
                    {...commonProps}
                    routingParams={{ ...params, showGAApprovedData }}
                    getCtaLink={getKeywordsCtaLink}
                    unlockHook={keywordsUnlockHook}
                    renderTextInsteadOfLinks={props.renderTextInsteadOfLinks}
                />
            </MetricContainer>
        </MetricsRow>
    );
};

const mapStateToProps = (props) => {
    const { common } = props;
    const { showGAApprovedData } = common;
    return {
        showGAApprovedData,
    };
};

export default connect(mapStateToProps)(WWOSearchTrafficOrganic);
